import React, { useEffect, useState } from 'react';
import { APP_TERMS } from '../../../app-terms';
import { Checkbox, Col, Form, Row, Table, Typography } from 'antd';
import PropTypes from 'prop-types';
import { CASE_FORM_TYPES } from '../../../appContants';

const { Text } = Typography;

const AddServices = ({ form, servicesList }) => {
  const [tableData, setTableData] = useState(servicesList || []);
  const columns = [
    {
      title: 'Select',
      dataIndex: 'isSelected',
      render: (value, record) => {
        return (
          <Checkbox
            checked={value}
            onChange={(e) => {
              const newData = [...tableData].map((item) => {
                return {
                  ...item,
                  isSelected: false,
                  hasRush: false,
                };
              });
              const index = newData.findIndex(
                (item) => record.serviceId === item.serviceId
              );
              newData.splice(index, 1, {
                ...record,
                isSelected: e?.target?.checked,
              });
              setTableData(newData);
            }}
          />
        );
      },
    },
    {
      title: 'Rush Fee',
      dataIndex: 'hasRush',
      render: (value, record) => {
        const disabled = !record?.isSelected;
        return (
          <Checkbox
            disabled={disabled}
            checked={value || false}
            onChange={(e) => {
              const newData = [...tableData].map((item) => {
                return {
                  ...item,
                  hasRush: false,
                };
              });
              const index = newData.findIndex(
                (item) => record.serviceId === item.serviceId
              );
              newData.splice(index, 1, {
                ...record,
                hasRush: e?.target?.checked,
              });
              setTableData(newData);
            }}
          />
        );
      },
    },
    {
      title: 'Name',
      dataIndex: 'title',
      render: (value) => {
        return <Text style={{ textWrap: 'wrap' }}>{value}</Text>;
      },
    },
    {
      title: 'Price',
      dataIndex: 'amount',
      align: 'right',
    },
    {
      title: 'Rush Fee',
      dataIndex: 'rushFee',
      align: 'right',
    },
  ];

  // Initialise the table with existing form values
  useEffect(() => {
    // Initialize table data from available form data
    const values = form?.getFieldsValue();
    const tableItems = values?.services;
    const newTableData = [...tableData].map((d) => {
      const index = tableItems?.findIndex(
        (value) => value?.serviceId === d?.serviceId
      );
      return {
        ...d,
        isSelected: index > -1 ? tableItems[index]?.isSelected : d.isSelected,
        hasRush: index > -1 ? tableItems[index]?.hasRush : d.hasRush,
      };
    });
    setTableData(newTableData);
  }, []);

  // Update form fields
  useEffect(() => {
    const formData = tableData.filter((d) => d?.isSelected);
    form?.setFieldsValue({ services: formData });
  }, [tableData]);

  return (
    <Form
      name={CASE_FORM_TYPES.addServices}
      form={form}
      layout="vertical"
      autoComplete="off"
    >
      <Row gutter={16} className="mt-3">
        <Col>
          <h4>{`${APP_TERMS.generic_add} ${APP_TERMS.generic_services}`}</h4>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="services"
            required
            rules={[
              {
                message: APP_TERMS.case_service_invalid_validation,
                validator: (_, value) => {
                  return value?.length
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(APP_TERMS.case_service_invalid_validation)
                      );
                },
              },
            ]}
          >
            <Table
              columns={columns}
              dataSource={tableData}
              pagination={false}
              rowKey={(record) => record?.serviceId}
              summary={(pageData) => {
                let totalAmount = 0;
                let totalRushFee = 0;

                pageData.forEach(({ amount, rushFee, ...rest }) => {
                  if (rest?.isSelected) {
                    totalAmount += amount;
                    if (rest?.hasRush) {
                      totalRushFee += rushFee;
                    }
                  }
                });

                return (
                  <>
                    <Table.Summary.Row className="bg-light">
                      <Table.Summary.Cell index={0} colSpan={3}>
                        Sub Total
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={3} align="right">
                        <Text type="danger">{totalAmount}</Text>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={4} align="right">
                        <Text>{totalRushFee}</Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                    <Table.Summary.Row
                      className="bg-light"
                      style={{ fontWeight: 'bolder' }}
                    >
                      <Table.Summary.Cell index={0} colSpan={3}>
                        Total
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={1} colSpan={2} align="right">
                        <Text type="danger">{totalAmount + totalRushFee}</Text>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  </>
                );
              }}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

AddServices.propTypes = {
  form: PropTypes.any,
  servicesList: PropTypes.array,
};
export default AddServices;
